<template>
  <div style="position: relative; align-self: center">
    <div
      tabindex="-1"
      class="button"
      @click="openSendTokensForm"
      :data-tooltip="$t('tokens_modal.button_send_tokens_tooltip')"
      ontouchstart
    >
      <div class="icon"></div>
    </div>
    <SendTokensModal
      v-if="open_modal"
      @cancel="open_modal = !open_modal"
      :model="model"
      :post="post"
    />
  </div>
</template>

<script setup lang="ts">
import _NuxtApp from "~/types/NuxtApp";
import { Model } from "~/types/Model";
import { Post } from "~/types/Post";

const { $auth } = <_NuxtApp>useNuxtApp();
const $router = useRouter();

const { model, post } = defineProps<{
  model: Model;
  post: Post;
}>();

if (!model || !post) {
  throw new Error("model or post is not defined");
}

const open_modal = ref(false);

function openSendTokensForm() {
  if ($auth.check()) {
    open_modal.value = true;
    return;
  }
  $router.push({ name: "purchase.tokens" });
}
</script>

<style scoped lang="scss">
.button {
  /*width: 50px;
  height: 20px;*/
  border-radius: 5px;
  text-align: center;
  /*background: #cccccc;*/
  cursor: pointer;
  // margin-bottom: 5px;
  overflow: hidden;
  font-weight: bold;
}

.icon {
  vertical-align: bottom;
  position: relative;

  $SIZE: 34px;

  width: $SIZE;
  height: $SIZE;
  background-size: contain;
  // background-repeat: no-repeat;
  background-position: center;
  background-image: var(--img-btn-min-dolar);
}

.button:hover::before,
.button:active::before,
.button:focus::before {
  content: attr(data-tooltip);
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateX(-100%) translateY(-50%);
  background-color: black;
  color: white;
  border-radius: 0.5rem;
  padding: 0.3rem 0.5rem;
  font-size: 0.8rem;
}
</style>
